import { ButtonGhostV2, colors2, icons, SANS_3, SANS_4_5, UI_BODY_SEMIBOLD_DF, UI_BODY_SM_DF } from 'oolib';
import React, { useEffect, useRef } from "react";
import { DropdownSingle } from 'oolib';
import { useAppSettingsContext } from '../../../../contexts/appSettingsContext';
import { __CheckAccessToPrivatePlatform } from "../../../../utils/accessControl";

//config
import { useGetQueryData } from "../../../../utils/react-query-hooks/general";
import { HamLink } from './comps/HamLink';
import {
  StyledHumburgerMenu, StyledLinksWrapper, StyledMenuHeader, StyledMenuSection,
  StyledMenuSectionLabel, StyledHamburgerBackdrop, StyledCloseButton
} from './styled';
import { genLinksConfigAsOptions } from './utils/genLinksConfigAsOptions';
import { trackEventGA } from '../../../../trackers/GA/trackEventGA';
import { MyAccountMenu } from '../PrimaryHeaderV2/HeaderUI/comps/MyAccountMenu';


const { Translate } = icons;


const HamburgerMenuV2 = ({ hamburgerOpen, setHamburgerOpen, _Nav, builderProps }) => {
  
  const hamburgerMenuRef = useRef(null);

  const { deployment: { _AppLanguageOptions }, } = useGetQueryData('platformConfigs');
  const { APP_SETTINGS, APP_SETTINGS_DISPATCH} = useAppSettingsContext();
  const userData = useGetQueryData('userData');


  useEffect(()=> {
    document.body.style.overflow = hamburgerOpen ? 'hidden' : 'auto';
    
    return ()=> document.body.style.overflow = 'auto'; //uppon comp removal reset body overflow to normal
  }, [hamburgerOpen])


  const closeHamburgerMenu = () => setHamburgerOpen(false);

  return (
    <>
    <StyledHamburgerBackdrop opened={hamburgerOpen} onClick={closeHamburgerMenu} />
      {hamburgerOpen && (
            <StyledCloseButton GhostV2
              icon="X"
              onClick={closeHamburgerMenu}
              iconSize={20}
              style={{ left: hamburgerMenuRef.current?.offsetWidth + 20 + "px" }}
            />
        )}
    <StyledHumburgerMenu opened={hamburgerOpen} id={"okf-HamburgerMenuV2"} ref={hamburgerMenuRef}> {/* Id required of Coachmarks */}
        
      {userData?.user && <MyAccountMenu />}
      
      {_AppLanguageOptions && _AppLanguageOptions.length > 1 && 
        <StyledMenuSection style={{display: 'flex', alignItems: 'center', gap: '1rem'}} >
          <Translate size={20}/>
          <UI_BODY_SM_DF>Language</UI_BODY_SM_DF>
          <DropdownSingle
            value= {APP_SETTINGS.lang}
            options={_AppLanguageOptions}
            S
            onChange={(k, v) => {
              
              trackEventGA("Language Flow","HamBurger Language Change",`${v?.value}`)
              APP_SETTINGS_DISPATCH({ type: "SET_LANG", payload: v})
            }}
          />
        </StyledMenuSection>
      }
      { __CheckAccessToPrivatePlatform(userData?.user) &&
        genLinksConfigAsOptions(_Nav).map(item => {
          if(item.folder || item.menu){ //menu is the deprecated term
            let thisFolder = item.folder || item.menu;
            return (thisFolder.length > 0 || !!builderProps) && (
              <StyledMenuSection id={item.display || item.value} key={item.display}>
                  {item.display &&
                      <StyledMenuSectionLabel id={item.display}>
                        {item.display}
                      </StyledMenuSectionLabel> }
                      <StyledLinksWrapper>
                          {thisFolder.map(d => <HamLink key={d.value} thisNavConfig={d} to={d.to} display={d.display} onClick={closeHamburgerMenu}/>)}
                      </StyledLinksWrapper>
              </StyledMenuSection>
            )   
          }else{
            return <StyledMenuSection key={item.value} id={item.display || item.value}>
              <StyledLinksWrapper>
                <HamLink thisNavConfig={item} to={item.to} display={item.display} onClick={closeHamburgerMenu}/>
              </StyledLinksWrapper>
            </StyledMenuSection>
          }
        })
      }

    </StyledHumburgerMenu>
    </>
  );
  
}

export default HamburgerMenuV2